import { Menu } from '@fluentui/react-northstar';
import { ToolbarTheme } from '@fluentui/react-teams/lib/esm/components/Toolbar/ToolbarTheme';
import React from 'react';
import { BreadCrumbItemProps, EditTicketToolbar } from '../../shared/components/EditTicketToolbar';
import { EditTicketState } from './editTicketState';
import { MenuItem } from './hooks/useTicketMenuItems';
import Style from './TicketToolbarSection.module.css';

interface TicketToolbarSectionProps {
  state: EditTicketState;
  ticketId: any;
  currentUserId: any;
  isItemSelected: boolean;
  isUserLicensed: boolean;
  mergedTicketIds: number[];
  breadcrumbItems: BreadCrumbItemProps[];
  globalTheme: any;
  onToolbarInteraction: (action: any) => Promise<void> | void;
}

/**
 * Renders the EditTicket page top toolbar (breadcrumbs + actions). Splits into
 * the "signed-in" and "still-loading-user" variants used by the legacy
 * implementation.
 */
const TicketToolbarSectionImpl: React.FC<TicketToolbarSectionProps> = ({
  state,
  ticketId,
  currentUserId,
  isItemSelected,
  isUserLicensed,
  mergedTicketIds,
  breadcrumbItems,
  globalTheme,
  onToolbarInteraction
}) => (
  <div className="print-hidden" style={{ marginBottom: '-18px' }}>
    <ToolbarTheme globalTheme={globalTheme}>
      <>
        {!state.isGettingSignedInUser && (
          <EditTicketToolbar
            ticketData={state.ticket}
            ticketId={ticketId}
            currentUserId={currentUserId}
            onInteraction={onToolbarInteraction}
            disabledSave={state.isSavingState}
            edittingState={state.isEditting}
            breadcrumbItems={breadcrumbItems}
            isItemSelected={isItemSelected}
            isUserLicensed={isUserLicensed}
            mergedTicketIds={mergedTicketIds}
          />
        )}
        {state.isGettingSignedInUser && (
          <EditTicketToolbar
            ticketData={state.ticket}
            ticketId={ticketId}
            currentUserId={null}
            disabledSave={state.isSavingState}
            edittingState={state.isEditting}
            breadcrumbItems={breadcrumbItems}
            isItemSelected={isItemSelected}
            isUserLicensed={isUserLicensed}
            mergedTicketIds={mergedTicketIds}
          />
        )}
      </>
    </ToolbarTheme>
  </div>
);

export const TicketToolbarSection = React.memo(TicketToolbarSectionImpl);

interface ContentMenuProps {
  menu: number;
  menuItems: MenuItem[];
  menuIndexChange: (e: any, props: any) => void;
}

/** Tab strip at the top of the center pane (activity / lifecycle / etc.). */
const ContentMenuImpl: React.FC<ContentMenuProps> = ({ menu, menuItems, menuIndexChange }) => (
  <div
    className={`md:relative md:bottom-auto w-full md:w-auto print-hidden ${Style.ticketTabStrip}`}
    style={{ marginTop: '0.5rem' }}
  >
    <Menu
      defaultActiveIndex={menu}
      items={menuItems}
      underlined
      primary
      onActiveIndexChange={menuIndexChange}
    />
  </div>
);

export const ContentMenu = React.memo(ContentMenuImpl);
